import type {Recipe} from './types';

export const piadinaRomagnola: Recipe = {
    id: 15,
    key: "piadinaRomagnola",
    pictures: [
        {index: 0, url: "https://www.tavolartegusto.it/wp/wp-content/uploads/2020/03/Piadina-romagnola-Ricetta-piadina.jpg"},
    ],
    i18n: {
        IT: {
            title: "Piadina Romagnola",
            servings: "6 piadine",
            ingredients: [
                "500 gr di farina 00",
                "220 gr di acqua",
                "70 gr di strutto",
                "1 cucchiaino raso di bicarbonato",
                "1 cucchiaino raso di sale",
            ],
            steps: [
                "Mettere in una ciotola farina, sale, strutto e bicarbonato.",
                "Impastare a mano sciogliendo e incorporando lo strutto alle polveri.",
                "Continuare a impastare aggiungendo acqua a poco a poco fino a incorporare tutta la farina rimasta sul fondo della ciotola e formare una palla.",
                "Coprire la ciotola con pellicola trasparente e lasciare riposare a temperatura ambiente per 40 minuti (non serve il calore perché deve compattarsi non lievitare).",
                "Tirare l'impasto fuori dalla ciotola e impastare nuovamente e dividere in palline da 130 - 140 gr ciascuna e rimettere le palline a riposare per 15 minuti coperte con la pellicola.",
                "Stendere le palline col mattarello (non serve farina aggiuntiva perché l'impasto è unto e non appiccica). Fare le piadine molto sottili (2 mm circa) cuocendosi lo spessore aumenterà abbastanza.",
                "Cuocere le piadine una ad una su una padella antiaderente a fuoco medio girandole spesso per controllare che non si brucino.",
                "Per mangiarle subito cuocerle a dovere, altrimenti se le volete surgelare cuocerle leggermente da entrambi i lati. La cottura finirà in padella dopo averle tolte dal freezer.",
                "Se volete surgelare le piadine, consiglio di metterle una sopra all'altra dividendole con la carta per alimenti in modo che non si incollino.",
            ],
            notes: "Potete sostituire lo strutto con la stessa quantità d'olio. Provare a giocare con strutto e bicarbonato per trovare il giusto equilibrio.",
        },
        EN: {
            title: "Piadina Romagnola bread",
            servings: "6 piadinas",
            ingredients: [
                "500 grams of 00 flour",
                "220 grams of water",
                "70 grams of lard",
                "1 level teaspoon of baking soda",
                "1 level teaspoon of salt",
            ],
            steps: [
                "Put the flour, salt, lard, and baking soda in a bowl.",
                "Knead by hand, dissolving and incorporating the lard into the dry ingredients.",
                "Continue kneading, adding water little by little until all the flour at the bottom of the bowl is incorporated and a ball is formed.",
                "Cover the bowl with plastic wrap and let it rest at room temperature for 40 minutes (no heat needed as it needs to compact, not rise).",
                "Take the dough out of the bowl, knead again, and divide into balls of 130 - 140 grams each, and let the balls rest for 15 minutes covered with plastic wrap.",
                "Roll out the balls with a rolling pin (no additional flour needed as the dough is greasy and non-sticky). Make the piadinas very thin (about 2 mm); they will thicken as they cook.",
                "Cook the piadinas one by one on a non-stick pan over medium heat, turning them often to ensure they do not burn.",
                "To eat them immediately, cook them properly, otherwise, if you want to freeze them, cook them lightly on both sides. The cooking will finish in the pan after taking them out of the freezer.",
                "If you want to freeze the piadinas, I recommend stacking them separated by food paper so they don't stick together.",
            ],
            notes: "You can replace the lard with the same amount of oil. Try experimenting with lard and baking soda to find the right balance.",
        },
        PL: {
            title: "Piadina Romagnola chleb",
            servings: "6 piadiny",
            ingredients: [
                "500 gramów mąki 00",
                "220 gramów wody",
                "70 gramów smalcu",
                "1 płaska łyżeczka sody oczyszczonej",
                "1 płaska łyżeczka soli",
            ],
            steps: [
                "Umieść mąkę, sól, smalec i sodę oczyszczoną w misce.",
                "Ugniataj ręcznie, rozpuszczając i mieszając smalec z suchymi składnikami.",
                "Kontynuuj zagniatanie, dodając wodę stopniowo, aż do włączenia całej mąki z dna miski i utworzenia kuli.",
                "Przykryj miskę folią spożywczą i pozostaw na 40 minut w temperaturze pokojowej (nie trzeba podgrzewać, ponieważ ciasto musi się ujednolicić, a nie wyrastać).",
                "Wyjmij ciasto z miski, ponownie zagnieć i podziel na kulki po 130 - 140 gramów każda i pozostaw kulki na 15 minut pod przykryciem z folii spożywczej.",
                "Rozwałkuj kulki wałkiem (nie potrzeba dodatkowej mąki, ponieważ ciasto jest tłuste i nie klei się). Zrób bardzo cienkie piadiny (około 2 mm); podczas gotowania będą się zagęszczać.",
                "Gotuj piadiny pojedynczo na nieprzywierającej patelni na średnim ogniu, często je obracając, aby się nie przypaliły.",
                "Aby zjeść je od razu, gotuj je odpowiednio, w przeciwnym razie, jeśli chcesz je zamrozić, gotuj je lekko z obu stron. Gotowanie zakończy się na patelni po wyjęciu z zamrażarki.",
                "Jeśli chcesz zamrozić piadiny, zalecam układanie ich w stosy, oddzielając papierem spożywczym, aby się nie sklejały.",
            ],
            notes: "Możesz zastąpić smalec taką samą ilością oleju. Spróbuj eksperymentować ze smalcem i sodą oczyszczoną, aby znaleźć odpowiednią równowagę.",
        },
    },
};
